import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { FacultyFormValues } from "src/models/Faculty.model";

type Props = {
  formikProps: FormikProps<FacultyFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const Faculty = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add Faculty" : "Update Faculty"}{" "}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="facultyName"
            required
            value={values.facultyName}
            onChange={(e) => {
              setFieldValue("facultyName", e.target.value);
            }}
            label="Faculty Name"
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default Faculty;
